<template>
  <TsContentPage />
</template>


<script setup lang="ts">
const TsContentPage = defineAsyncComponent(
    () => import('~/components/builder/TsContentPage.vue')
);
definePageMeta({
  layout: false
})

</script>